<template>
  <div class="video-list-container">
    <div class="sub-title sepBottom S4 C8" @click="showPicker = !showPicker">
      {{ selectDate || '全部' }}
      <van-icon class="arrow-icon" name="arrow-down" />
    </div>
    <div
      class="select-pannel"
      v-if="showPicker"
      @click.self="hiddenPick"
      :style="{
        top: contentHeight
          ? `${getClientHeight(contentHeight) + 510 / 75}rem`
          : `${510 / 75}rem`
      }"
    >
      <ul class="list-content">
        <li
          v-for="(item, index) in monthList"
          :key="index"
          class="select-key-tab"
          @click="checkSelectFun(item, index)"
          :class="{
            'select-key-tab-active': activeSelectKey === index
          }"
        >
          <span>{{ item.name }}</span
          ><van-icon
            class="my-icon"
            name="success"
            v-if="activeSelectKey === index"
          />
        </li>
        <template v-if="videoList.length < 3">
          <li class="select-key-tab nodata"></li>
          <li class="select-key-tab nodata"></li>
        </template>
      </ul>
    </div>
    <div class="nodata-container" v-if="videoList.length == 0">
      <img src="../../static/ic_charge_empty.png" alt="" />
      <div class="S6 T3">暂无课程</div>
    </div>
    <template v-else>
      <van-list
        v-model="loading"
        :finished="pageEnd"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          v-for="item in videoList"
          :key="item.courseId"
          @click="playCourseVideo(item)"
        >
          <CategoryItem
            :item="item"
            :isShrink="true"
            :hightLight="item.videoIdentity === currentVideo"
          />
        </div>
      </van-list>
    </template>
  </div>
</template>

<script>
import CategoryItem from '../video/CatelogItem'
import { mapState } from 'vuex'
import { Icon, Toast, List } from 'vant'
import comm from '@/comm'
import api from '@/api/api'
import dayjs from 'dayjs'

export default {
  name: 'CourseVideoCatalog',
  props: ['contentHeight'],
  components: {
    CategoryItem,
    'van-icon': Icon,
    'van-list': List
  },
  data() {
    return {
      isAsc: false,
      showPicker: false,
      selectDate: '全部',
      videoList: [],
      activeSelectKey: 0,
      monthList: [],
      pageEnd: false,
      loading: false,
      viewState: ''
    }
  },
  created() {
    this.videoList = this.resp?.detail?.courses?.page
      ? this.resp.detail.courses.page.list
      : []
    this.monthList = this.resp?.detail?.courses?.monthList
    this.viewState = this.resp?.result.viewState
  },
  computed: {
    ...mapState('video', ['resp', 'currentVideo'])
  },

  methods: {
    dayjs,
    playCourseVideo(course) {
      if (course.isHightlight) {
        Toast('正在播放课程花絮，购买后观看完整课程。')
      }
      this.$emit('playCourseVideo', course)
    },
    sortVideo() {
      const param = {
        monthString: this.selectDate,
        courseSetId: comm.getQueryString('setId'),
        pageSize: this.activeSelectKey === 0 ? 10 : 100,
        direction: this.viewState ? 2 : 0
      }
      this.loading = true
      api.course.getCourseList(param, this.viewState).then(res => {
        if (res.result.code === 0) {
          if (res.detail.page.flush || this.viewState === '') {
            this.videoList = res.detail?.page?.list
          } else {
            this.videoList = this.videoList.concat(res.detail?.page?.list)
          }
          this.viewState = res.result.viewState
          this.pageEnd = this.activeSelectKey === 0 ? res.detail.page.end : true
          this.loading = false
          this.$nextTick(() => this.$emit('updateSwiper'))
        }
      })
    },
    onLoad() {
      if (this.activeSelectKey === 0) {
        this.sortVideo()
      }
    },
    hiddenPick() {
      this.showPicker = false
    },
    checkSelectFun(val, ind) {
      this.activeSelectKey = ind
      this.selectDate = val.value
      this.viewState = ''
      this.sortVideo()
      this.hiddenPick()
    },
    getClientHeight(val) {
      return (val * (750 / document.body.clientWidth)) / 75
    }
  }
}
</script>

<style scoped lang="scss">
.sub-title {
  padding-left: 30px;
  padding-right: 30px;
  display: flex;
  height: 80px;
  align-items: center;
}
.nodata-container {
  width: 100%;
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.nodata-container img {
  width: 400px;
  height: 224px;
}

.video-list-container {
  position: relative;
}
.finished {
  color: #969799;
  font-size: 24px;
  line-height: 50px;
  text-align: center;
}
.select-pannel {
  position: fixed;
  top: 510px;
  left: 0;
  background-color: rgba($color: #000000, $alpha: 0.5);
  width: 100%;
  z-index: 1;
  height: 120%;
  .list-content {
    height: 400px;
    overflow-y: auto;
  }
  .select-key-tab {
    padding: 36px 30px 32px;
    background: #fff;
    border-bottom: 1px solid #ebebeb;
  }

  .select-key-tab:last-child,
  .select-key-tab.nodata {
    border: none;
  }
  .nodata {
    height: 60px;
  }
  .select-key-tab-active {
    color: #046bcc;
  }
  .my-icon {
    float: right;
  }
}
</style>
